import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { loadUser } from "../home/userSlice";

export const updateDisplayName = createAsyncThunk(
    'displayName/updateDisplayName',
    async ({username, newDisplayName, token}) => {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/user/users/${username}/updateDisplayName`,
            {
                method: 'PUT',
                headers: { 
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: newDisplayName
            }
        )
        .then(response => response.json());
        return response;
    }
)

export const loadUserAfterDisplayNameUpdate = createAsyncThunk(
    'displayName/loadUserAfterDisplayNameUpdate',
    async ({username, newDisplayName, token}, {dispatch}) => {
        const updateDisplayNameResult = await dispatch(updateDisplayName({username, newDisplayName, token}));

        if (updateDisplayName.fulfilled.match(updateDisplayNameResult)) {
            dispatch(loadUser({token, username}));
        }
    }
)

export const displayNameSlice = createSlice({
    name: 'displayName',
    initialState: {
        confirmingDisplayNameUpdate: false,
        updatingDisplayName: false,
        failedToUpdateDisplayName: false,
        newDisplayName: ""
    },
    reducers: {
        changeFormDisplayName: (state, action) => {
            return {
                ...state,
                newDisplayName: action.payload
            }
        },
        changeConfirmingDisplayNameUpdate: (state, action) => {
            return {
                ...state,
                confirmingDisplayNameUpdate: action.payload
            }
        }
    },
    extraReducers: {
        [updateDisplayName.pending]: (state) => {
            return {
                ...state,
                updatingDisplayName: true,
                failedToUpdateDisplayName: false
            }
        },
        [updateDisplayName.fulfilled]: (state) => {
            return {
                ...state,
                updatingDisplayName: false,
                failedToUpdateDisplayName: false,
                newDisplayName: ""
            }
        },
        [updateDisplayName.rejected]: (state) => {
            return {
                ...state,
                updatingDisplayName: false,
                failedToUpdateDisplayName: true
            }
        }
    }
})

export const selectDisplayName = (state) => state.displayName.newDisplayName;
export const displayNameUpdating = (state) => state.displayName.updatingDisplayName;
export const selectConfirmingDisplayNameUpdate = (state) => state.displayName.confirmingDisplayNameUpdate;

export const { changeFormDisplayName, changeConfirmingDisplayNameUpdate } = displayNameSlice.actions;

export default displayNameSlice.reducer;